module.exports = __webpack_public_path__ + "img/icon2-4.95140e75.png";